/*** IMPORTS FROM imports-loader ***/
import Translator from "bazinga-translator";

(function (t) {
// lv
t.add("cart.tickets.no_available_tickets_for_seating", "Izv\u0113l\u0113taj\u0101m s\u0113dviet\u0101m bi\u013cetes nav pieejamas", "PayseraCartBundle", "lv");
t.add("cart.tickets.no_available_tickets", "Bi\u013cetes nav pieejamas ", "PayseraCartBundle", "lv");
t.add("paysera_cart.discount.invalid_code", "Neder\u012bgs atlaides kods ", "PayseraCartBundle", "lv");
})(Translator);
